/* ĀHUA theme JS — no dependencies */
(function () {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  function money(cents) {
    const fmt = (window.ahua && window.ahua.moneyFormat) || '${{amount}}';
    const amount = (cents / 100).toFixed(2);
    const noDec = (cents / 100) % 1 === 0 ? (cents / 100).toFixed(0) : amount;
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, amount);
  }

  /* ---------- mobile menu ---------- */
  const header = $('#SiteHeader');
  const toggle = $('[data-menu-toggle]');
  if (toggle && header) {
    toggle.addEventListener('click', () => {
      const open = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  /* ---------- cart drawer ---------- */
  const drawer = $('[data-cart-drawer]');
  function renderCart(cart) {
    $$('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; el.dataset.count = cart.item_count; });
    if (!drawer) return;
    const box = $('[data-cart-items]', drawer);
    const sub = $('[data-cart-subtotal]', drawer);
    if (sub) sub.textContent = money(cart.total_price);
    if (!box) return;
    if (!cart.items.length) { box.innerHTML = '<p class="lede" style="padding:2rem 0;text-align:center">Nothing here yet.</p>'; return; }
    box.innerHTML = cart.items.map(i => `
      <div class="drawer__item">
        ${i.image ? `<img src="${i.image.replace(/(\.[a-z]+)(\?.*)?$/i, '_200x200$1$2')}" alt="">` : ''}
        <div>
          <div class="drawer__item-title">${i.product_title.replace(' — iPhone Duo Case', '')}</div>
          <div class="drawer__item-meta">${i.variant_title || ''} · ${i.quantity} × ${money(i.price)}</div>
          <button class="drawer__remove" type="button" data-remove="${i.key}">Remove</button>
        </div>
      </div>`).join('');
  }
  function openDrawer() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  async function fetchCart() { const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } }); return r.json(); }

  $$('[data-cart-open]').forEach(b => b.addEventListener('click', async e => { e.preventDefault(); renderCart(await fetchCart()); openDrawer(); }));
  $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeDrawer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });
  if (drawer) drawer.addEventListener('click', async e => {
    const btn = e.target.closest('[data-remove]'); if (!btn) return;
    const r = await fetch(window.ahua.routes.cart_change_url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: btn.dataset.remove, quantity: 0 }) });
    renderCart(await r.json());
  });

  /* ---------- product form ---------- */
  const productEl = $('[data-product]');
  if (productEl) {
    const json = $('#' + productEl.dataset.productJson);
    const product = json ? JSON.parse(json.textContent) : null;
    const form = $('[data-product-form]', productEl);
    const idInput = $('[data-variant-id]', form);
    const price = $('[data-price]', productEl);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const mainImg = $('[data-main-image]', productEl);
    const thumbs = $$('[data-thumb]', productEl);
    const defaultLabel = addLabel ? addLabel.textContent : '';

    function selectedOptions() {
      return $$('.option', form).map(f => { const c = $('input:checked', f); return c ? c.value : null; });
    }
    function showMedia(id, src) {
      if (mainImg && src) { mainImg.removeAttribute('srcset'); mainImg.removeAttribute('sizes'); mainImg.src = src; }
      thumbs.forEach(t => t.classList.toggle('is-active', String(t.dataset.mediaId) === String(id)));
    }
    function updateVariant() {
      if (!product) return;
      const opts = selectedOptions();
      const v = product.variants.find(v => v.options.every((o, i) => o === opts[i]));
      $$('.option', form).forEach((f, i) => { const s = $('[data-option-value]', f); if (s) s.textContent = opts[i] || ''; });
      if (!v) { addBtn.disabled = true; addLabel.textContent = window.ahua.strings.unavailable; return; }
      idInput.value = v.id;
      if (price) price.textContent = money(v.price);
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? defaultLabel : window.ahua.strings.soldOut;
      if (v.featured_media) {
        const t = thumbs.find(t => String(t.dataset.mediaId) === String(v.featured_media.id));
        showMedia(v.featured_media.id, t ? t.dataset.src : null);
      }
      const url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url);
    }
    $$('.option input', form).forEach(i => i.addEventListener('change', updateVariant));
    thumbs.forEach(t => t.addEventListener('click', () => showMedia(t.dataset.mediaId, t.dataset.src)));

    form.addEventListener('submit', async e => {
      e.preventDefault();
      addBtn.disabled = true; addLabel.textContent = window.ahua.strings.adding;
      try {
        const r = await fetch(window.ahua.routes.cart_add_url + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: idInput.value, quantity: 1 }) });
        if (!r.ok) throw new Error((await r.json()).description || 'Could not add');
        renderCart(await fetchCart()); openDrawer();
      } catch (err) {
        alert(err.message);
      } finally {
        addBtn.disabled = false; addLabel.textContent = defaultLabel;
      }
    });
  }

  /* ---------- password page countdown ---------- */
  const cd = $('[data-countdown]');
  if (cd) {
    const target = new Date(cd.dataset.countdown).getTime();
    const tick = () => {
      const d = Math.max(0, target - Date.now());
      const days = Math.floor(d / 864e5), hrs = Math.floor(d % 864e5 / 36e5), min = Math.floor(d % 36e5 / 6e4);
      cd.innerHTML = `<div><b>${days}</b>days</div><div><b>${hrs}</b>hours</div><div><b>${min}</b>min</div>`;
    };
    tick(); setInterval(tick, 30000);
  }
})();
